

export const SERVICES ={
    CATALOG: {
        list: "models/list",
        count: "models/count",
        linkVari: "models/virtualTryOn"
    },
    BRAND:{
        list: "brands/list",
        setposition: "brands/setPosition"
    },
    ARTICLES: {
        list: "articles/list",
        price: "articles/price",
        eanCode: "articles/getByEanCode",
        upcCode: "articles/getByUpcCode"
    },
    MARKET_AREAS:{
        list:"common/listMarketAreas"
    },
    CLIENTS: {
        list: "clients/list",
        count: "clients/count",
        save: "clients/save",
        get:"clients/getClient"
    },
    FILTERS: {
        collection: "models/filters/collection",
        colors: "models/filters/colors",
        material : "models/filters/material",
        seasonYear: "models/filters/seasonYear",
        size: "models/filters/size",
        concept: "models/filters/concept",
        shape: "models/filters/shape",
        lensMaterial: "models/filters/lensMaterials",
        caliber: "models/filters/caliber",
        theme: "models/filters/theme"
    },
    PROPOSALS:{
        list:"proposals/list",
        count:"proposals/count",
        save:"proposals/save",
        get:"proposals/get",
        delete:"proposals/delete",
        send:"proposals/send",
        add:"proposals/add",
        remove:"proposals/remove",
        getArticles:"proposals/getArticles",
        duplicate:"proposals/duplicate",
        countArticles: "proposals/countArticles",
        lastClusters:"clients/lastClusters",
        export: "proposals/export",
        exportSummary: "proposals/exportSummary"
    },
    SELECTIONS:{
        list:"selections/list",
        count:"selections/count",
        save:"selections/save",
        get:"selections/get",
        delete:"selections/delete",
        export:"selections/export",
        add:"selections/add",
        remove:"selections/remove",
        getArticles:"selections/getArticles",
        duplicate:"selections/duplicate",
        duplicateAndMove:"selections/duplicateAndMove",
        createProposal: "selections/createProposal",
        getModels:"models/listForSelection",
        getModelsCount:"models/countForSelection",
        countArticles: "selections/countArticles",
        import:"selections/importSelection"
    },
    USER_MANAGEMENT: {
        upload:"api/v1/services/user/import",
        export:"api/v1/services/user/export",
        new: 'api/v1/services/user/add',
        edit: 'api/v1/services/user/edit',
        delete: 'api/v1/services/user/delete',
        entity:"user"
    },
    STORE_MANAGEMENT: {
        upload:"api/v1/services/store/import",
        export:"api/v1/services/store/export",
        entity:"stores"
    },
    COMPETITORS_MANAGEMENT: {
        upload:"api/v1/services/competitor/import",
        export:"api/v1/services/competitor/export",
        entity:"competitors"
    },
    COMPETITORS_IN_STORE: {
        upload:"api/v1/services/competitor/instore/import",
        export:"api/v1/services/competitor/instore/export",
        entity:"competitor_store"
    },
    COMPETITORS_SALES: {
        upload:"api/v1/services/report/competitorsalesdetails/import",
        export:"api/v1/services/report/competitorsalesdetails/export",
        entity:"competitor_sales_data"
    },
    TARGET_MANAGEMENT: {
        upload:"api/v1/services/target/import",
        export:"api/v1/services/target/export",
        entity:"target"
    },
    sellout: {
        export: 'api/v1/services/report/sellout/export'
    },
    sales_trends: {
        export: 'api/v1/services/report/salestrend/export'
    },
    sales_trends_with_competition: {
        export: 'api/v1/services/report/salestrendwithcompetition/export'
    },
    best_sellers: {
        export: 'api/v1/services/report/bestsellers/export'
    },
    stock: {
        export: 'api/v1/services/report/stock/export'
    },
    suppliers_by_store: {
        export: 'api/v1/services/report/brandranking/export'
    },
    top_10_rankings_by_store: {
        export: 'api/v1/services/report/rankingbystore/export'
    },
    store_to_store: {
        export: 'api/v1/services/report/storetostore/export'
    },
    sales_details: {
        export: 'api/v1/services/report/salesdetails/export'
    },
    popular_characteristics_color: {
        export: 'api/v1/services/report/popularcolorsandshapes/export'
    },
    popular_characteristics_material: {
        export: 'api/v1/services/report/popularmaterialsandprices/export'
    },
    stock_charts: {
        export: 'api/v1/services/report/stockcharts/export'
    },
    sales_data_competition: {
        export: 'api/v1/services/report/salesdatawithcompetition/export'
    },
    sales_data_competition_vs_last_year: {
        export: 'api/v1/services/report/salesdatawithcompetition/vslastyear/export'
    },
    competitor_sales_details: {
        export: 'api/v1/services/report/competitorsalesdetails/export',
    }
};
